export default {
  'apiTestCase.messageError.praseError': 'Parsing Error',
  'apiTestCase.messageError.csvFormatError': 'Does not conform to CSV format',
  'apiTestCase.csvStandardRules': '《Standard CSV Specification》',
  'apiTestCase.report.statusCode': 'Status',
  'apiTestCase.report.statusLabel': 'HTTP Status: ',
  'apiTestCase.report.timeConsume': 'Time',
  'apiTestCase.report.TabSizeMap': 'Size',
  'apiTest.label.actualRequest': 'Actual Request',
  'apiText.response.timings.event': 'EVENT',
  'apiText.response.timings.event.prepare': 'Prepare',
  'apiText.response.timings.event.socket': 'Socket Initialization',
  'apiText.response.timings.event.dns': 'DNS Lookup',
  'apiText.response.timings.event.tcp': 'TCP Handshake',
  'apiText.response.timings.event.ssl': 'SSL Handshake',
  'apiText.response.timings.event.transfer': 'Waiting (TTFB)',
  'apiText.response.timings.event.download': 'Content Download',
  'apiText.response.timings.event.process': 'Processing',
  'apiText.response.timings.event.total': 'Total',
  'apiText.response.timings.timeLabel': 'TIME',
  'apiTest.debug.extension.install': 'Install',
  'apiTest.debug.extension.install.tips':
    'Please install the {appName} browser extension to send requests. Supports Chrome and Edge browsers only.',
  'apiText.response.error.message.fallback': 'Error: {message}',
  'apiText.response.error.help': 'help',
  'apiTest.debug.usedTemplateVar': 'The API uses environment variables {variables}',
  'apiTest.debug.setTemplateVar': 'Please set the environment variables {variables}',
  'apiTest.debug.toSetVar': 'Go to set value',
  'apiTestCase.threadResources': 'Thread resource preparation in progress',
};
